import useUI from 'hooks/use-ui';
import useDispensary from 'src/dispensary/hooks/use-dispensary';
import { useRequestHost } from 'contexts/request-host';
import PublicEnv from 'shared/utils/public-env';

import { resolveStoreFrontHost } from './utils';

export default function useStoreFrontOrigin(): string {
  const UI = useUI();
  const { dispensary } = useDispensary();
  const requestHost = useRequestHost();

  const currentHost = requestHost ?? (typeof window !== `undefined` ? window.location.host : ``);
  const customDomain = dispensary?.customDomainSettings?.domain;
  const isStoreFront = UI.isVariant(`store-front`);

  const canonicalHost = resolveStoreFrontHost({ currentHost, customDomain, isStoreFront });

  return canonicalHost ? `https://${canonicalHost}` : PublicEnv.consumerUrl;
}
